import React from "react";
import Modal from "react-modal";
import Button, { ButtonThemes } from "ui-components/button/button";
import "../../../sass/modal.scss";
import "./closeDoorModal.scss";

Modal.setAppElement("#root");

// Custom centered modal style
const centeredModalStyle = {
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.7)",
    zIndex: 1001,
    position: "fixed" as const,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  content: {
    position: "relative" as const,
    top: "auto",
    left: "auto",
    right: "auto",
    bottom: "auto",
    margin: "auto",
    transform: "none",
    padding: "24px",
    maxWidth: "520px",
    maxHeight: "90vh",
    width: "100%",
    border: "1px solid #E0E0E0",
    borderRadius: "4px",
    background: "#fff",
    overflow: "auto",
  }
};

interface CloseDoorModalProps {
  isOpen: boolean;
  onClose: () => void;
  manifestNumber?: string;
  doorNumber?: string;
  destinationTerminal?: string;
  loadPercentage?: number;
  pieces?: number;
  weight?: number;
  onConfirm: () => void;
}

const CloseDoorModal: React.FC<CloseDoorModalProps> = ({
  isOpen,
  onClose,
  manifestNumber,
  doorNumber,
  destinationTerminal,
  loadPercentage,
  pieces,
  weight,
  onConfirm,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      style={centeredModalStyle}
      onRequestClose={onClose}
      className="close-door-modal"
      overlayClassName="close-door-modal-overlay"
      ariaHideApp={false}
    >
      <div className="xgs-modal__header">
        <div className="close-door-modal__title">Close Door?</div>
        <button
          className="xgs-modal__close"
          onClick={onClose}
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            padding: 0,
            fontSize: "20px",
            color: "#666",
          }}
        >
          ×
        </button>
      </div>
      <div className="xgs-modal__content">
        <div className="close-door-modal__message">
          Once the door is closed, unloading will be marked as complete. You won't be able to edit door, trailer, or freight details.
        </div>

        <div className="close-door-modal__summary">
          <div className="close-door-modal__summary-title">Load Summary</div>
          <div className="close-door-modal__summary-card">
            <div className="close-door-modal__summary-content">
              <div className="close-door-modal__summary-row">
                <span className="label">Manifest:</span>
                <span className="value">{manifestNumber || "-"}</span>
              </div>

              <div className="close-door-modal__summary-row">
                <span className="label">Door:</span>
                <span className="value">{doorNumber || "-"}</span>
              </div>

              <div className="close-door-modal__summary-row">
                <span className="label">Destination:</span>
                <span className="value">{destinationTerminal || "-"}</span>
              </div>

              <div className="close-door-modal__summary-row">
                <span className="label">Load %:</span>
                <span className="value">{loadPercentage ?? 0}%</span>
              </div>

              <div className="close-door-modal__summary-row">
                <span className="label">Pieces:</span>
                <span className="value">{pieces || "-"}</span>
              </div>

              <div className="close-door-modal__summary-row">
                <span className="label">Weight:</span>
                <span className="value">
                  {weight ? `${weight.toLocaleString("en-US")} lbs` : "-"}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="xgs-modal__buttons" style={{ textAlign: "right", marginTop: "24px" }}>
          <Button
            type="button"
            theme={ButtonThemes.gray}
            onClick={onClose}
            className="xgs-modal__button"
          >
            Cancel
          </Button>
          <Button
            type="button"
            theme={ButtonThemes.blue}
            onClick={onConfirm}
            className="xgs-modal__button"
          >
            Confirm
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default CloseDoorModal;

